module.exports = __webpack_public_path__ + "img/m_top_happybrain.92f4ef4c.jpg";